<template>
    <div class="  is-fullheight sticky-sidebar" >
      <aside class="menu column  aside   is-fullheight" >
       <p class="menu-label">
Notes
       </p>
       <ul class="menu-list">
         <li>
           <a class="">General</a>
           <ul>
             <li @click="activeMenuLink = '/notes'"><router-link to="/notes"  :class="{'is-active':activeMenuLink === '/notes'}">View Notes</router-link></li>
             <li @click="activeMenuLink = '/notes/add'"><router-link to="/notes/add"  :class="{'is-active':activeMenuLink === '/notes/add'}">Add Note</router-link></li>
           </ul>
         </li>
         
         
         
         
       </ul>
       
       
       
     </aside>
     
    </div>
 </template>
 
 <script>
 export default {
   name: 'SideBarNotes',
   components: {
   },
   data() {
     return { activeMenuLink: null }
   },
   mounted() {
     //this.activeMenuLink = this.$route.path.substring(1)
     this.activeMenuLink = this.$route.path
     console.log(this.activeMenuLink)
   },
   watch: {
    $route () { 
      
      this.activeMenuLink = this.$route.path
    },
    

  }
 }
 
 </script>